module.exports = __webpack_public_path__ + "static/media/azure.9e52229d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/azure.png
// module id = 864
// module chunks = 6